export const palette = {
  LightGrey: "#e2e8f0",
  Grey: "#b1b1b1",
  CoolGray: "#768597",
  LikeBlack: "#262f3d",
  Purple: "#1AC486",
  ElectricBlue: "#1AC486",
  ElectricBlueLight: "#e8f3ff",
  MintGreen: "#69FABD",
  MidnightBlue: "#1A212A",
  Cyan: "#0bc5ea",
};

export const theme = {
  global: {
    focus: {
      border: {
        color: "transparent",
      },
    },

    colors: {
      text: palette.LikeBlack,
      brand: palette.Purple,
      background: "white",
      backgroundBack: "#f3f3f3",
      backgroundEmptyIcon: "#e8e6e6",
      backgroundDropdownItem: "#fdf9f9",
      backgroundBackEmpty: "#f3f3f3",
      border: palette.LightGrey,
      headerText: "#ffffff",
      majorText: palette.MidnightBlue,
      minorText: palette.CoolGray,
      primaryText: palette.LikeBlack,
      iconMain: palette.ElectricBlue,
      tableRow: palette.ElectricBlueLight,
      mintGreen: palette.MintGreen,
      errorText: "#ff0000",
      successText: "#14a266",
      backgroundError: "rgba(230, 0, 0, 0.4)",
      backgroundSuccess: "rgb(106 250 188 / 44%)",
      backgroundToaster: "rgba(0, 174, 233, 0.7)",
      backgroundTip: "#f3f3f3",
      link: palette.Cyan,
      buttonText: palette.MidnightBlue,
    },
    palette,
    select: {
      clear: {
        color: "brand",
      },
    },

    font: {
      family: "Poppins",
      // family: "Fira Sans",
      size: "14px",
      height: "20px",
    },
  },
  anchor: {
    textDecoration: "none",
    hover: {
      textDecoration: "none",
    },
  },
  button: {
    // backgroundColor: "transparent",
    color: "brand",
    borderColor: "brand",
  },
  dataTable: {
    body: {
      extend: (props: any) => `
        tr:first-child {
          th, td {
            border: none;
          }
        }
        
        tr {
          th, td {
            padding: 16px 8px;
          }
          td:last-child {
            text-align: right;
          }
        }
        
        tr:nth-child(even) {
          th, td {
             background-color: ${props.theme.global.colors.tableRow};
          }
        }
      `,
    },
  },
};

export const darkTheme = {
  ...theme,
  select: {
    container: {
      extend: () => [{ color: "#ffffff" }],
    },
  },
  global: {
    focus: {
      border: {
        color: "transparent",
      },
    },
    hover: {
      background: palette.MidnightBlue,
    },
    colors: {
      brand: palette.Purple,
      background: palette.MidnightBlue,
      backgroundBack: "#10141A",
      backgroundDropdownItem: "#262f3d",
      backgroundEmptyIcon: "#324a92",
      border: "#262f3d",
      headerText: "#ffffff",
      majorText: palette.MidnightBlue,
      minorText: "#768597",
      primaryText: "#f2f5f9",
      iconMain: palette.ElectricBlue,
      tableRow: "#122852",
      mintGreen: palette.MintGreen,
      errorText: "#ff5858",
      successText: "#00d67b",
      backgroundError: "rgba(230, 0, 0, 0.4)",
      backgroundSuccess: "rgb(106 250 188 / 23%)",
      backgroundToaster: "rgb(93 111 181 / 70%)",
      selected: palette.Purple,
      backgroundTip: "#22577E",
      link: palette.Cyan,
      buttonText: "#FFFFFF",
    },
    palette,
    font: {
      family: "Poppins",
      // family: "Fira Sans",
      size: "14px",
      height: "20px",
    },
  },
  tip: {
    content: {
      elevation: "none",
    },
  },
};
